module.exports = __webpack_public_path__ + "static/media/avatar.5b4c72f1.jpg";